import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getTokenFromTokenStore } from "../../config/Authentication";

const Authenticate = () => {
    const navigate = useNavigate();

    useEffect(() => {

        const redirectToLogin = () => {
            const redirectUri = encodeURIComponent(`/authenticated${window.location.search}`)
            window.location.replace(`/.auth/login/aad?post_login_redirect_uri=${redirectUri}`)
        }

        function isTokenExpired(token: string) {
            const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
            return (Math.floor((new Date()).getTime() / 1000)) >= expiry;
        }

        getTokenFromTokenStore()
            .then(token => {
                if (!token)
                    // token missing - redirecting to login
                    redirectToLogin();
                else {
                    // token exists
                    if (isTokenExpired(token)) {
                        //but expired - try refresh
                        fetch('/.auth/refresh').then((response) => {
                            if (response.ok) {
                                // refresh succeeded - redirecting to authenticated
                                navigate({
                                    pathname: '/authenticated',
                                    search: window.location.search,
                                })
                            } else {
                                // refresh failed - redirecting to login
                                redirectToLogin();
                            }

                        })
                    } else {
                        navigate({
                            pathname: '/authenticated',
                            search: window.location.search,
                        })
                    }
                }

            }).catch((e) => {
                if (e.message === "Unauthorized") {
                    redirectToLogin();
                } else {
                    console.error(e)
                    //setError("Unfortunately, something went wrong. Please, try it again or contact the hotline.")
                }

            });


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return <div></div>
}

export default Authenticate